module.exports = __webpack_public_path__ + "static/media/sell_question_3.25cf0abf.jpg";